import { NgModule } from '@angular/core';
import { PatientClinicalSharedModule } from 'src/app/shared/components/patients/patient-clinical-shared.module';
import { VisSystemCodeModule } from 'src/app/shared/components/system-code/system-code.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReportHelperModule } from 'src/app/system/report/report-helper.module';
import { DentalDisabilityMemoModule } from 'src/app/hist/dental-disability-memo/dental-disability-memo.module';
import { PatientEditComponent } from '../edit/patients-edit.component';
import { PatientListComponent } from '../list/patients-list.component';
import { PatientContactComponent } from '../patient-contact/patient-contact.component';
import { PatientQueryDialogComponent } from './patient-query-dialog.component';

@NgModule({
  declarations: [
    PatientQueryDialogComponent,
    PatientListComponent,
    PatientEditComponent,
    PatientContactComponent,
  ],
  imports: [
    SharedModule,
    DentalDisabilityMemoModule,
    PatientClinicalSharedModule,
    ReportHelperModule,
    VisSystemCodeModule,
  ],
  exports: [
    PatientQueryDialogComponent,
    PatientListComponent,
    PatientEditComponent,
  ],
})
export class PatientQueryDialogModule { }
